var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00299 14.2513C4.02135 14.2513 2.5733 14.1053 2.5733 12.9027C2.5733 11.7001 2.61114 11.5909 3.03054 10.7894C3.44994 9.98785 4.78324 7.91072 5.01217 7.54643C5.2411 7.18214 5.50729 7 6.46025 7H12.0523C13.5382 7 15.101 8.23881 15.6725 8.60309C16.2439 8.96738 16.587 9.44142 17.311 9.47761C18.035 9.51381 20.093 10.024 20.7786 10.9353C21.4641 11.8467 21.4263 12.5384 21.4263 12.9395C21.4263 13.3406 21.3884 14.2513 20.4739 14.2513H6.00299Z",
    fill: "url(#paint0_linear_468_75593)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M10.308 7.89082V9.4965C10.308 9.71942 10.4538 9.90049 10.6335 9.90049H14.8168C15.1276 9.90049 15.2606 9.41146 15.0144 9.17551C14.5617 8.74202 13.9248 8.21868 13.2335 7.91826C12.266 7.49781 11.1579 7.47037 10.6259 7.48683C10.4494 7.49232 10.308 7.67134 10.308 7.89082Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07321 16.3117C7.13411 16.3117 7.99413 15.452 7.99413 14.3915C7.99413 13.331 7.13411 12.4713 6.07321 12.4713C5.01231 12.4713 4.15228 13.331 4.15228 14.3915C4.15228 15.452 5.01231 16.3117 6.07321 16.3117Z",
    fill: "url(#paint1_linear_468_75593)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07326 16.358C4.98848 16.358 4.10663 15.4759 4.10663 14.3922C4.10663 13.3084 4.98908 12.4263 6.07326 12.4263C7.15744 12.4263 8.03989 13.3084 8.03989 14.3922C8.03989 15.4759 7.15744 16.358 6.07326 16.358ZM6.07326 12.5176C5.03906 12.5176 4.19804 13.3583 4.19804 14.3922C4.19804 15.426 5.03906 16.2667 6.07326 16.2667C7.10747 16.2667 7.94848 15.426 7.94848 14.3922C7.94848 13.3583 7.10747 12.5176 6.07326 12.5176Z",
    fill: "url(#paint2_linear_468_75593)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5525 16.3117C18.6134 16.3117 19.4734 15.452 19.4734 14.3915C19.4734 13.331 18.6134 12.4713 17.5525 12.4713C16.4916 12.4713 15.6316 13.331 15.6316 14.3915C15.6316 15.452 16.4916 16.3117 17.5525 16.3117Z",
    fill: "url(#paint3_linear_468_75593)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5524 16.358C16.4676 16.358 15.5858 15.4759 15.5858 14.3922C15.5858 13.3084 16.4682 12.4263 17.5524 12.4263C18.6366 12.4263 19.5191 13.3084 19.5191 14.3922C19.5191 15.4759 18.6366 16.358 17.5524 16.358ZM17.5524 12.5176C16.5182 12.5176 15.6772 13.3583 15.6772 14.3922C15.6772 15.426 16.5182 16.2667 17.5524 16.2667C18.5866 16.2667 19.4276 15.426 19.4276 14.3922C19.4276 13.3583 18.5866 12.5176 17.5524 12.5176Z",
    fill: "url(#paint4_linear_468_75593)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_75593",
    x1: 1.23031,
    y1: 14.6577,
    x2: 19.5378,
    y2: 4.96788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE3704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_468_75593",
    x1: 4.15228,
    y1: 14.3916,
    x2: 7.99413,
    y2: 14.3916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_468_75593",
    x1: 4.10663,
    y1: 14.3922,
    x2: 8.03989,
    y2: 14.3922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_468_75593",
    x1: 15.6316,
    y1: 14.3916,
    x2: 19.4734,
    y2: 14.3916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_468_75593",
    x1: 15.5858,
    y1: 14.3922,
    x2: 19.5191,
    y2: 14.3922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorCar);
export default __webpack_public_path__ + "static/media/color-car.57ef3bffcaa114599423ba0e946f4f74.svg";
export { ForwardRef as ReactComponent };